import styled from 'styled-components';
import { useState } from 'react';
import { getPricesFromRange } from './utils/gridUtils';
import { Slider } from '../Slider';
import { LocalizedCurrency } from '../LocalizedCurrency';
import { Input } from './Input';
import { useCurrencyLocalizer } from '../../hooks/useCurrencyLocalizer';

const getSliderRange = (data: { min: number; max: number }) => {
  return [(data?.min || 100) / 100, (data?.max || 1000000000) / 100];
};

export const PriceFilters = ({
  data,
  currentSelection,
  setCurrentSelection,
}: {
  data: any;
  toggleSelection: any;
  setCurrentSelection: any;
  currentSelection: any;
}) => {
  const [isSliderValue, setIsSliderValue] = useState(true);
  const [hasPriceError, setPriceError] = useState({ min: '', max: '' });
  const sliderRange = getSliderRange(data);

  const { getCurrencySymbol } = useCurrencyLocalizer();

  const onSliderChange = (values: any) => {
    if (isSliderValue === true) {
      setIsSliderValue(true);
      const r: any = {
        start: values[0],
      };
      if (values[1] !== 10000) {
        // eslint-disable-next-line prefer-destructuring
        r.end = values[1];
      }
      setCurrentSelection(r);
    }
  };

  const selectedPriceRange = getPricesFromRange([...currentSelection][0] || '');

  const currentCurrencySymbol = getCurrencySymbol();

  // console.log(selectedPriceRange.end);
  return (
    <div className="pt-4">
      <PriceFilters.PriceSliderKeys>
        <LocalizedCurrency
          price={(selectedPriceRange.start || selectedPriceRange.end || sliderRange[0]) * 100}
          roundDownToDollarAmount
        />
        <span>
          <LocalizedCurrency
            price={(selectedPriceRange.end || sliderRange[1]) * 100}
            roundDownToDollarAmount
          />
        </span>
      </PriceFilters.PriceSliderKeys>

      <PriceFilters.SliderWrapper>
        {currentSelection.size > 1 && !isSliderValue ? (
          <PriceFilters.Line />
        ) : (
          <Slider
            data-qa="price_filter_slider"
            handleSlideEnd={(val) => {
              setIsSliderValue(true);
              onSliderChange(val);
            }}
            handleUpdate={onSliderChange}
            values={[
              selectedPriceRange?.start || selectedPriceRange.end || sliderRange[0],
              selectedPriceRange.end || sliderRange[1],
            ]}
            step={1}
            range={[sliderRange[0], sliderRange[1]]}
          />
        )}
      </PriceFilters.SliderWrapper>
      {/* translate here */}
      <div
        className="box-border"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 8px',
          marginTop: 48,
          gap: 16,
        }}
      >
        <Input
          data-qa="mobile_filter_min_price_input"
          // label={t(`${TP}.confirmationCode`, '5-6 Digit Confirmation Code')}
          label="Min price"
          id="min_price"
          name="min_price"
          value={selectedPriceRange.start || ''}
          hasError={Boolean(hasPriceError.min)}
          errorMessage={hasPriceError.min}
          max={10000}
          showLabel
          onChange={(e) => {
            setIsSliderValue(false);
            const currentMin = Number.parseInt(e.target.value, 10);
            if (currentMin < 1) {
              setPriceError({
                ...hasPriceError,
                min: 'Amount must be greater than 1',
              });
            } else {
              setPriceError({ ...hasPriceError, min: '' });
            }
            setCurrentSelection({
              start: Number.parseInt(e.target.value, 10),
              end: selectedPriceRange.end,
            });
          }}
          onBlur={(e) => {
            const currentMin = Number.parseInt(e.target.value, 10);
            if (selectedPriceRange?.end) {
              if (currentMin > selectedPriceRange?.end) {
                setPriceError({
                  ...hasPriceError,
                  min: 'Min price must be less than max price',
                });
              } else if (hasPriceError.max === 'Max price must be greater than min price') {
                setPriceError({ ...hasPriceError, max: '' });
              }
            }
          }}
          prefix={getCurrencySymbol()?.isSuffix ? '' : getCurrencySymbol()?.symbol}
          suffix={getCurrencySymbol()?.isSuffix ? getCurrencySymbol()?.symbol : ''}
          type="number"
          hasFloatingLabel={false}
        />
        <Input
          data-qa="mobile_filter_max_price_input"
          // label={t(`${TP}.confirmationCode`, '5-6 Digit Confirmation Code')}
          label="Max price"
          id="max_price"
          name="max_price"
          max={10000}
          value={selectedPriceRange.end || ''}
          hasError={Boolean(hasPriceError.max)}
          errorMessage={hasPriceError.max}
          onChange={(e) => {
            setIsSliderValue(false);
            const currentMax = Number.parseInt(e.target.value, 10);
            if (currentMax > 10000) {
              setPriceError({
                ...hasPriceError,
                max: 'Amount must be less than 10000',
              });
            } else {
              setPriceError({ ...hasPriceError, max: '' });
            }
            setCurrentSelection({
              end: Number.parseInt(e.target.value, 10),
              start: selectedPriceRange.start,
            });
          }}
          onBlur={(e) => {
            const currentMax = Number.parseInt(e.target.value, 10);
            if (selectedPriceRange?.start) {
              if (currentMax < selectedPriceRange?.start) {
                setPriceError({
                  ...hasPriceError,
                  max: 'Max price must be greater than min price',
                });
              } else if (hasPriceError.min === 'Min price must be less than max price') {
                setPriceError({ ...hasPriceError, min: '' });
              }
            }
          }}
          showLabel
          prefix={currentCurrencySymbol?.isSuffix ? '' : currentCurrencySymbol?.symbol}
          suffix={currentCurrencySymbol?.isSuffix ? currentCurrencySymbol?.symbol : ''}
          type="number"
          hasFloatingLabel={false}
        />
      </div>

      {/* buttons ranges */}
      {/* <div className="box-border">
        {Object.keys(multiSelectRanges).map((priceRange) => {
          return (
            <DropdownTrigger
              data-qa="mobile_filter_price_button"
              key={priceRange}
              title={getDisplayCurrentPrice(multiSelectRanges[priceRange])}
              onClick={() => {
                setCurrentSelection(multiSelectRanges[priceRange]);
              }}
              isSelected={currentSelection.has(priceRange)}
              height={22}
            />
          );
        })}
      </div> */}
    </div>
  );
};

PriceFilters.Line = styled.hr`
  background-color: #000000;
  opacity: 1;
`;

PriceFilters.MultipleRangesSelected = styled.div`
  text-align: center;
`;

PriceFilters.PriceSliderKeys = styled.div`
  display: flex;
  justify-content: space-between;
`;

PriceFilters.SliderWrapper = styled.div`
  margin: 24px 8px;
  padding: 0 8px;
`;
